import type { Entry } from '@ozone/shared';

/**
 * AOZONE-34: count how many entries are flagged for the MBR. Only an explicit
 * `includeInMbr === true` counts as selected — legacy rows with no field (and
 * explicit `false`) are not.
 */
export function tally(entries: Entry[]): { selected: number; total: number } {
  const selected = entries.reduce((n, e) => n + (e.includeInMbr === true ? 1 : 0), 0);
  return { selected, total: entries.length };
}

export function filterSelected(entries: Entry[], showSelectedOnly: boolean): Entry[] {
  return showSelectedOnly ? entries.filter((e) => e.includeInMbr === true) : entries;
}
